module.exports = __webpack_public_path__ + "files/Participant_list_example.e1860791.xlsx";